import axios from 'axios';
import withCancellation from '../withCancellation';

const instance = axios.create({
  withCredentials: true,
});

export default withCancellation(instance);
